import { db, fb } from './firebase';

export const getFamilies = async () => {
  const userID = fb.auth().currentUser.uid;
  const userRef = await db
    .collection('users').doc(userID)
    .get();
  const hallID = userRef.get('hall');
  const familiesRef = await db
    .collection('halls').doc(hallID)
    .collection('families')
    .orderBy('lastName')
    .get();
  const families = familiesRef.docs.map((familyRef) => {
    return { id: familyRef.id, ...familyRef.data() };
  });
  return families;
}

export const getFamilyByEmail = async () => {
  const userID = fb.auth().currentUser.uid;
  const userRef = await db
    .collection('users').doc(userID)
    .get();
  const hallID = userRef.get('hall');
  const email = userRef.get('email');
  const familiesByEmailRef = await db
    .collection('halls').doc(hallID)
    .collection('families')
    .where('emails', 'array-contains', email)
    .limit(1)
    .get();
  const familyByEmail = familiesByEmailRef.docs.map((familyRef) => {
    return { id: familyRef.id, ...familyRef.data() };
  }); 
  return familyByEmail[0];
}

export const joinFamily = async (family) => {
  const userID = fb.auth().currentUser.uid;
  try {
    await db
      .collection('users').doc(userID)
      .update('family', family.id);
  } catch (e) {
    console.error(e.message);
    throw e;
  }
}

export const searchFamilies = async (searchString) => {
  const terms = searchString.split(' ', 10).map((lower) => lower.replace(/^\w/, c => c.toUpperCase()));
  const userID = fb.auth().currentUser.uid;
  const userRef = await db
    .collection('users').doc(userID)
    .get();
  const hallID = userRef.get('hall');
  const familiesByAdultsRef = await db
    .collection('halls').doc(hallID)
    .collection('families')
    .where('adults', 'array-contains-any', terms)
    .get();
  const familiesByDependentsRef = await db
    .collection('halls').doc(hallID)
    .collection('families')
    .where('dependents', 'array-contains-any', terms)
    .get();
  const familiesByLastNameRef = await db
    .collection('halls').doc(hallID)
    .collection('families')
    .where('lastName', 'in', terms)
    .get();
  const familiesByAdults = familiesByAdultsRef.docs.map((familyRef) => {
    return { id: familyRef.id, ...familyRef.data() };
  });
  const familiesByDependents = familiesByDependentsRef.docs.map((familyRef) => {
    return { id: familyRef.id, ...familyRef.data() };
  });
  const familiesByLastName = familiesByLastNameRef.docs.map((familyRef) => {
    return { id: familyRef.id, ...familyRef.data() };
  });
  const families = new Set([
    ...familiesByAdults,
    ...familiesByDependents,
    ...familiesByLastName,
  ]);
  return [...families];
}

export const createFamily = async (family) => {
  const userID = fb.auth().currentUser.uid;
  const userRef = await db
    .collection('users').doc(userID)
    .get();
  const hallID = userRef.get('hall');
  const role = userRef.get('role');
  try {
    const docRef = await db
      .collection('halls').doc(hallID)
      .collection('families')
      .add(family);
    const { id } = docRef;
    family.id = id;
    if (role !== 'admin') {
      joinFamily(family);
    }
  } catch (e) {
    console.error(e.message);
    throw e;
  }
}

export const updateFamily = async (family) => {
  const userID = fb.auth().currentUser.uid;
  const userRef = await db
    .collection('users').doc(userID)
    .get();
  const hallID = userRef.get('hall');
  const role = userRef.get('role');
  const familyID = userRef.get('family');
  const { id } = family;
  if (role !== 'admin' && familyID !== id) {
    console.error('Unauthorized edit.');
    return;
  }
  delete family.id;
  try {
    await db
      .collection('halls').doc(hallID)
      .collection('families').doc(id)
      .update(family);
  } catch (e) {
    console.error(e.message);
  }
}



	